import { gql } from '@apollo/client'

// mutation name added
export default gql(`
    mutation batchArchiveVirtualAssets($ids : [ID!] $project: String $module: String) {
        batchArchiveVirtualAssets(
            assets: $ids
            project: $project
            module: $module
        )
    }`
)
